import { render, staticRenderFns } from "./wcrd_bus_own_priv_lic.vue?vue&type=template&id=cf16f74e&scoped=true&"
import script from "./wcrd_bus_own_priv_lic.vue?vue&type=script&lang=js&"
export * from "./wcrd_bus_own_priv_lic.vue?vue&type=script&lang=js&"
import style0 from "./wcrd_bus_own_priv_lic.vue?vue&type=style&index=0&id=cf16f74e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf16f74e",
  null
  
)

export default component.exports